import React from "react"
import { useSelector } from "react-redux"

import { selectScopedByClient } from "../../../stores/appSlice"
import AccountingBatchTable from "./components/AccountingBatchTable"
import AccountingBatchForm from "./components/AccountingBatchForm"
import BillTable from "./components/BillTable"
import DashboardPlaceholder from "../../../components/utilityComponents/placeholders/DashboardPlaceholder"

export default function AccountingBatchPage({ view, recordSelected }) {
    const scopedByClient = useSelector(selectScopedByClient)

    const renderView = () => {
        switch (view) {
            case "dashboard":
                return renderDashboard()
            case "index":
                return renderIndex()
            case "form":
                return renderForm()
            case "bills":
                return renderBills()
            // case "subaccounts":
            //     return renderSubaccounts()
            default:
                return renderIndex()
        }
    }

    const renderDashboard = () => {
        if (!scopedByClient) {
            return null
        }

        return <DashboardPlaceholder />
    }

    const renderIndex = () => {
        if (scopedByClient) {
            return <AccountingBatchTable scopedByClient={scopedByClient} />
        }

        return <AccountingBatchTable scopedByClient={scopedByClient} />
    }

    const renderForm = () => {
        return (
            <>
                <h1>Manage Client Batch</h1>
                <AccountingBatchForm actionName="new" />
            </>
        )
    }

    const renderBills = () => {
        return <BillTable scopedByClient={scopedByClient} />
    }

    // const renderSubaccounts = () => {
    //     return <SubaccountTable scopedByClient={scopedByClient} />
    // }

    return <>{renderView()}</>
}
